module.exports = __webpack_public_path__ + "media/images/lb/352-552ec271e7c41275cd3bcc41597f443c.svg";